import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './layout/Navbar';
import HorizontalNavbar from './layout/HorizontalNavbar';
import VerticalNavbar from './layout/VerticalNavbar';
import Login from './components/Login';
import OwnerDashboard from './components/OwnerDashboard';
import AgentDashboard from './components/AgentDashboard';
import ChangePassword from './components/ChangePassword';
import AgentForm from './components/AgentForm';
import BulkAgentForm from './components/BulkAgentForm';
import FileUpload from './components/FileUpload';
import HomePage from './pages/HomePage';
import OurVision from './pages/OurVision';
import OurMission from './pages/OurMission';
import OurStory from './pages/OurStory';
import ContactUs from './pages/ContactUs';
import Pricing from './pages/Pricing';
import Services from './pages/Services';
import Features from './pages/Features';
import ContactForm from './pages/ContactForm';
import AboutUs from './pages/AboutUs';
import LastLogin from './components/LastLogin'; // Import LastLogin component
import './css/styles.css';

function App() {
    const [userRole, setUserRole] = useState(null);
    const [userId, setUserId] = useState(null);
    const [passwordChangeRequired, setPasswordChangeRequired] = useState(false);

    const handleLogout = () => {
        setUserRole(null);
        setUserId(null);
        setPasswordChangeRequired(false);
        localStorage.clear();
    };

    const ProtectedRoute = ({ roles, children }) => {
        if (!roles.includes(userRole)) {
            return <Navigate to="/login" />;
        }
        return children;
    };

    return (
        
            <Router basename="/app"> 

            <Navbar userRole={userRole} onLogout={handleLogout} />
            <Routes>
                <Route
                    path="/login"
                    element={
                        <Login
                            setUserRole={setUserRole}
                            setUserId={setUserId}
                            setPasswordChangeRequired={setPasswordChangeRequired}
                        />
                    }
                />
                <Route
                    path="/"
                    element={
                        <>
                            <HorizontalNavbar />
                            <div className="main-layout">
                                <VerticalNavbar userRole={userRole} />
                                <div className="main-content">
                                    <HomePage />
                                </div>
                            </div>
                        </>
                    }
                />
                <Route
                    path="/our-mission"
                    element={
                        <>
                            <HorizontalNavbar />
                            <div className="main-layout">
                                <VerticalNavbar userRole={userRole} />
                                <div className="main-content">
                                    <OurMission />
                                </div>
                            </div>
                        </>
                    }
                />
                <Route
                    path="/our-vision"
                    element={
                        <>
                            <HorizontalNavbar />
                            <div className="main-layout">
                                <VerticalNavbar userRole={userRole} />
                                <div className="main-content">
                                    <OurVision />
                                </div>
                            </div>
                        </>
                    }
                />
                <Route
                    path="/our-story"
                    element={
                        <>
                            <HorizontalNavbar />
                            <div className="main-layout">
                                <VerticalNavbar userRole={userRole} />
                                <div className="main-content">
                                    <OurStory />
                                </div>
                            </div>
                        </>
                    }
                />
                <Route
                    path="/contact-us"
                    element={
                        <>
                            <HorizontalNavbar />
                            <div className="main-layout">
                                <VerticalNavbar userRole={userRole} />
                                <div className="main-content">
                                    <ContactUs />
                                </div>
                            </div>
                        </>
                    }
                />
                <Route
                    path="/Pricing"
                    element={
                        <>
                            <HorizontalNavbar />
                            <div className="main-layout">
                                <VerticalNavbar userRole={userRole} />
                                <div className="main-content">
                                    <Pricing />
                                </div>
                            </div>
                        </>
                    }
                />
                <Route
                    path="/Services"
                    element={
                        <>
                            <HorizontalNavbar />
                            <div className="main-layout">
                                <VerticalNavbar userRole={userRole} />
                                <div className="main-content">
                                    <Services />
                                </div>
                            </div>
                        </>
                    }
                />
                <Route
                    path="/Features"
                    element={
                        <>
                            <HorizontalNavbar />
                            <div className="main-layout">
                                <VerticalNavbar userRole={userRole} />
                                <div className="main-content">
                                    <Features />
                                </div>
                            </div>
                        </>
                    }
                />
                
                <Route
                    path="/AboutUs"
                    element={
                        <>
                            <HorizontalNavbar />
                            <div className="main-layout">
                                <VerticalNavbar userRole={userRole} />
                                <div className="main-content">
                                    <AboutUs />
                                </div>
                            </div>
                        </>
                    }
                />
                <Route
                    path="/ContactForm"
                    element={
                        <>
                            <HorizontalNavbar />
                            <div className="main-layout">
                                <VerticalNavbar userRole={userRole} />
                                <div className="main-content">
                                    <ContactForm />
                                </div>
                            </div>
                        </>
                    }
                />
                <Route
                    path="/ownerdashboard"
                    element={
                        <ProtectedRoute roles={['PRIMARY', 'SECONDARY']}>
                            <OwnerDashboard userId={userId} />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/agentdashboard"
                    element={
                        <ProtectedRoute roles={['AGENT']}>
                            <AgentDashboard userId={userId} />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/change-password"
                    element={userRole ? <ChangePassword setPasswordChangeRequired={setPasswordChangeRequired} /> : <Navigate to="/login" />}
                />
                <Route
                    path="/AgentForm"
                    element={
                        <ProtectedRoute roles={['PRIMARY']}>
                            <AgentForm />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/BulkAgentForm"
                    element={
                        <ProtectedRoute roles={['PRIMARY']}>
                            <BulkAgentForm />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/FileUpload"
                    element={
                        <ProtectedRoute roles={['AGENT']}>
                            <FileUpload />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/last-login"
                    element={
                        <ProtectedRoute roles={['PRIMARY', 'SECONDARY', 'AGENT']}>
                            <LastLogin userId={userId} />
                        </ProtectedRoute>
                    }
                />
                
                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
        </Router>
    );
}

export default App;